import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useEstateOptions } from '@/api/estate-options';
import { FieldSelect } from '@/components/form/field-select';

import type { EstateValidationSchemaType } from '../../schemas/estate-validation';

export const EnergyForm = () => {
  const { t } = useTranslation();
  const { data: estateOptions } = useEstateOptions();

  const methods = useFormContext<EstateValidationSchemaType>();

  const countryId = methods.watch('address.countryId');

  const energyClasses = useMemo(() => {
    const energyClasses = estateOptions?.energyClasses ? [...estateOptions.energyClasses] : [];
    const lastIndex = energyClasses.findIndex(({ id }) => id === (countryId === 'AT' ? 'G' : 'H'));
    return lastIndex > -1 ? energyClasses.splice(0, lastIndex + 1) : energyClasses;
  }, [estateOptions, countryId]);

  return (
    <div className="space-y-2">
      <h4 className="text-md font-bold">{t('energyCertificate')}</h4>
      <FieldSelect
        methods={methods}
        name="estateEnergyDetails.hwbClass"
        label={t('hwbClass')}
        options={energyClasses}
      />
    </div>
  );
};
